import type { BillingStatus } from '@/types/subscription';

/** A Stripe subscription still exists, so a plan change goes through `change_plan`, not a new checkout. */
export function hasLiveSubscription(status?: BillingStatus): boolean {
  if (!status) return false;
  if (status.state === 'read_only') return status.reason === 'payment_lapsed';
  return status.state === 'active' || status.state === 'past_due' || status.state === 'cancelled';
}
